import { Model } from '@nozbe/watermelondb';
import { field } from '@nozbe/watermelondb/decorators';

function parseJsonArray(value: string): string[] {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export default class DemoOrderMaster extends Model {
  static table = 'demo_order_master_information';

  @field('bp_order_master_owner_id') bpOrderMasterOwnerId!: string;
  @field('bp_order_master_employee_id') bpOrderMasterEmployeeId!: string;
  @field('bp_order_customer_information') bpOrderCustomerInformation!: string;
  @field('bp_order_customer_email_information')
  bpOrderCustomerEmailInformation!: string;
  @field('bp_order_customer_phone_number_information')
  bpOrderCustomerPhoneNumberInformation!: string;
  @field('bp_order_customer_information_updated_at')
  bpOrderCustomerInformationUpdatedAt!: number;
  @field('bp_order_master_order_status') bpOrderMasterOrderStatus!: string;
  @field('bp_order_master_payment_information')
  bpOrderMasterPaymentInformation!: string;
  @field('bp_order_master_receipt_reference_id')
  bpOrderMasterReceiptReferenceId!: string;
  @field('bp_order_master_receipt_ref_id_updated_at')
  bpOrderMasterReceiptRefIdUpdatedAt!: number;
  @field('bp_sales_products_information') bpSalesProductsInformation!: string;
  @field('bp_order_master_created_at') bpOrderMasterCreatedAt!: number;
  @field('bp_order_master_updated_at') bpOrderMasterUpdatedAt!: number;
  @field('bp_order_master_deleted_at') bpOrderMasterDeletedAt!: number;
  @field('bp_order_master_location_id') bpOrderMasterLocationId!: string;
  @field('bp_order_master_order_total') bpOrderMasterOrderTotal!: number;

  get salesProductIds(): string[] {
    return parseJsonArray(this.bpSalesProductsInformation);
  }

  toOrderMasterObject() {
    return {
      bp_order_id: this.id,
      bp_order_master_owner_id: this.bpOrderMasterOwnerId,
      bp_order_master_employee_id: this.bpOrderMasterEmployeeId,
      bp_order_customer_information: this.bpOrderCustomerInformation,
      bp_order_customer_email_information: this.bpOrderCustomerEmailInformation,
      bp_order_customer_phone_number_information:
        this.bpOrderCustomerPhoneNumberInformation,
      bp_order_customer_information_updated_at:
        this.bpOrderCustomerInformationUpdatedAt,
      bp_order_master_order_status: this.bpOrderMasterOrderStatus,
      bp_order_master_payment_information: this.bpOrderMasterPaymentInformation,
      bp_order_master_receipt_reference_id:
        this.bpOrderMasterReceiptReferenceId,
      bp_order_master_receipt_ref_id_updated_at:
        this.bpOrderMasterReceiptRefIdUpdatedAt,
      bp_sales_products_information: this.salesProductIds,
      bp_order_master_created_at: this.bpOrderMasterCreatedAt,
      bp_order_master_updated_at: this.bpOrderMasterUpdatedAt,
      bp_order_master_deleted_at: this.bpOrderMasterDeletedAt,
      bp_order_master_location_id: this.bpOrderMasterLocationId,
      bp_order_master_order_total: this.bpOrderMasterOrderTotal,
    };
  }
}
